import { useEffect, useState } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import { useNavigate } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import perfumesImg from '@/assets/promo-perfumes.jpg';
import techImg from '@/assets/promo-tech.jpg';
import iphone17Img from '@/assets/promo-iphone17.jpg';
import abbasFastFoodImg from '@/assets/promo-abbas-fastfood.png';
import luigisComplexImg from '@/assets/promo-luigis-complex.png';
import sunuCafeImg from '@/assets/promo-sunu-cafe.png';
import abokiySuyaImg from '@/assets/promo-abokiy-suya.png';
const homePromos = [
  {
    id: 1,
    title: 'Abbas Fast Food is now on GAMBGO!',
    image: abbasFastFoodImg,
    link: '/restaurant/0167bcd6-703c-448e-adf6-16bb87be4277',
  },
  {
    id: 2,
    title: "Luigi's Complex is now on GAMBGO!",
    image: luigisComplexImg,
    link: '/restaurant/d7139c3c-212b-4f51-8ddf-755c1b5150f8',
  },
  {
    id: 3,
    title: 'SUŃU CAFE is now on GAMBGO!',
    image: sunuCafeImg,
    link: '/restaurant/d3c8ba52-9ec2-4df1-949a-62954efd34fd',
  },
  {
    id: 4,
    title: 'Abokiy Suya Spot is now on GAMBGO!',
    image: abokiySuyaImg,
    link: '/restaurant/384ed1ee-3372-4c1b-8d1f-901178138fcc',
  },
];

const marketplacePromos = [
  {
    id: 1,
    title: 'Get the New iPhone 17 Pro Max',
    image: iphone17Img,
    link: '/marketplace/vendor/324dd058-f501-4749-84a4-89cd36ce4002',
  },
  {
    id: 2,
    title: 'Shop Perfumes Under D800',
    image: perfumesImg,
    link: '/marketplace/vendor/bfd102e5-16d3-49df-b5de-ca010db44f96',
  },
  {
    id: 3,
    title: 'Shop Tech Deals',
    image: techImg,
    link: '/marketplace/technology',
  },
];

interface PromoBannerProps {
  type?: 'home' | 'marketplace';
}

const PromoBanner = ({ type = 'home' }: PromoBannerProps) => {
  const navigate = useNavigate();
  const promos = type === 'marketplace' ? marketplacePromos : homePromos;
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true });
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    if (!emblaApi) return;

    const onSelect = () => {
      setSelectedIndex(emblaApi.selectedScrollSnap());
    };

    emblaApi.on('select', onSelect);
    onSelect();

    // Auto-scroll every 4 seconds
    const autoScroll = setInterval(() => {
      emblaApi.scrollNext();
    }, 4000);

    return () => {
      clearInterval(autoScroll);
      emblaApi.off('select', onSelect);
    };
  }, [emblaApi]);

  return (
    <div className="mb-6">
      <div className="overflow-hidden" ref={emblaRef}>
        <div className="flex">
          {promos.map((promo) => (
            <div key={promo.id} className="flex-[0_0_100%] min-w-0">
              <Card 
                className={`overflow-hidden ${promo.link ? 'cursor-pointer hover:shadow-lg' : ''} transition-shadow`}
                onClick={() => promo.link && navigate(promo.link)}
              >
                <div className="relative h-40 sm:h-48">
                  <img
                    src={promo.image}
                    alt={promo.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end">
                    <h3 className="text-white font-bold text-xl sm:text-2xl p-4 w-full">
                      {promo.title}
                    </h3>
                  </div>
                </div>
              </Card>
            </div>
          ))}
        </div>
      </div>
      
      <div className="flex justify-center gap-2 mt-3">
        {promos.map((_, index) => (
          <button
            key={index}
            className={`h-2 rounded-full transition-all ${
              index === selectedIndex ? 'w-6 bg-primary' : 'w-2 bg-muted'
            }`}
            onClick={() => emblaApi?.scrollTo(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default PromoBanner;
